import { render, staticRenderFns } from "./TicketsAssignDialog.vue?vue&type=template&id=2f6bb68c&"
import script from "./TicketsAssignDialog.vue?vue&type=script&lang=js&"
export * from "./TicketsAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./TicketsAssignDialog.vue?vue&type=style&index=0&id=2f6bb68c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports